import { z } from 'zod';

/** Ajuda do app (Sessao 22): paginas do manual (docs/manual) entregues JA FILTRADAS pelo servidor segundo a permissao de quem pede. */
export interface AjudaIndiceItem {
  /** "telas/custos-rateios", "conceitos/cpm", "indice". */
  slug: string;
  titulo: string;
  grupo: 'conceitos' | 'telas' | 'geral';
}
export interface AjudaIndiceResponse {
  paginas: AjudaIndiceItem[];
}
export interface AjudaPaginaResponse extends AjudaIndiceItem {
  /** Markdown sem os blocos de custo/RH que o usuario nao pode ver (removidos no servidor). */
  texto: string;
}
export interface AjudaRotaResponse {
  slug: string | null;
}
export interface AjudaBuscaItem {
  titulo: string;
  /** Trecho (texto livre ou bloco permitido). */
  texto: string;
  /** Rota do web: /ajuda?p=<slug>#<secao>. */
  link: string;
}
export interface AjudaBuscaResponse {
  resultados: AjudaBuscaItem[];
}

export const ajudaPaginaQuerySchema = z.object({ p: z.string().regex(/^[a-z0-9][a-z0-9/-]{0,120}$/) });
export const ajudaRotaQuerySchema = z.object({ rota: z.string().min(1).max(200) });
export const ajudaBuscaQuerySchema = z.object({ q: z.string().trim().min(1).max(200) });
